export const UPDATE_ACTIVE_CARD = 'OTT/cardSuggest/UPDATE_ACTIVE_CARD';
export const GET_CARD_SUGGESTS = 'OTT/cardSuggest/GET_CARD_SUGGESTS';
export const RESET_CARD_SUGGEST = 'OTT/cardSuggest/RESET_CARD_SUGGEST';
export const REMOVE_CARD = 'OTT/cardSuggest/REMOVE_CARD';
export const REMOVE_CARD_SUCCESS = 'OTT/cardSuggest/REMOVE_CARD_SUCCESS';
export const REMOVE_CARD_FAIL = 'OTT/cardSuggest/REMOVE_CARD_FAIL';
export const RESET_REMOVE_CARD_ERROR = 'OTT/cardSuggest/RESET_REMOVE_CARD_ERROR';
export const SAVE_CARDS = 'OTT/cardSuggest/SAVE_CARDS';
export const CLEAR_CARD_LIST = 'OTT/cardSuggest/CLEAR_CARD_LIST';
